import { put, takeLatest } from "redux-saga/effects";
import { requestClientAgreementList } from "../../../../services/acclgl/reports/clientAgreement";
import {
  fetchClientAgreementListFailure,
  fetchClientAgreementListSuccess,
  fetchClientAgreementListRequest,
} from "redux/reducers/acclgl/reports/clientAgreement";
export function* watchClientAgreementReportSaga() {
  yield takeLatest(fetchClientAgreementListRequest, fetchClientAgreementList);
}

function* fetchClientAgreementList({ payload }) {
  try {
    const response = yield requestClientAgreementList(payload);
    yield put(fetchClientAgreementListSuccess(response));
  } catch (error) {
    yield put(
      fetchClientAgreementListFailure("Failed to get list of Client Agreement")
    );
  }
}
